import { Blocks, Cpu, Dessert, Gift, LogOut, PiggyBank, Settings, ShoppingCart } from "lucide-react";
import "../styles/sidebar.css";
import React, { useState , useRef ,useEffect} from "react";


import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import SidebarNavItems from "./SidebarNavItems";

export default function Sidebar({ dashboardCard1Object,onClose,pageDB,setPageDB }) {
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
      const [isLoaded, setIsLoaded] = useState(false);
      const [hasError, setHasError] = useState(false);
      
         
              const [reloadItems, setReloadItems] = useState(true);
             
                 useEffect(()=>{
                     setReloadItems(false); setReloadItems(true);
                     
                 },[ ])
    
                   
      return (
        <div style={{ position: "relative",boxShadow:boxShadow,
        overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
         borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                  
        width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
          {!isLoaded && !hasError && (
            <div
             style={
                 { 
                  borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                    position: "absolute",
          top: 0,
          left: 0,
          width: `${width}%`,
          aspectRatio: aspectRatio,
          objectFit: "cover",  }}
           className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
            >
              <img
            src={loading_img}
            alt=""
          
           style={
                 {
                 borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                  
                    position: "absolute",border:border,
          top: 0,
          left: 0,
          width: `${width}%`,padding:"10px",
        
          objectFit: "cover", aspectRatio: aspectRatio,  }}
           className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
          />
            </div>
          )}
          
          <img
    
          
            src={hasError ? fallback_img : src}
            alt=""
            onLoad={() => setIsLoaded(true)}
            onError={() => setHasError(true)}
           style={
                 {
                    position: "absolute",
          top: 0,
          left: 0,
          width: `${width}%`,
         
          objectFit: "cover",aspectRatio: aspectRatio  }}
           className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
          />
        
        </div>
      );
    };  return (
    <aside className="sidebarD"  style={{background:`${dashboardCard1Object?.sidebarBox?.bgColor?.color}`,
border:` ${dashboardCard1Object?.sidebarBox?.border?.borderWidth?.value+dashboardCard1Object?.sidebarBox?.border?.borderWidth?.resolution} ${dashboardCard1Object?.sidebarBox?.border?.borderType}  ${dashboardCard1Object?.sidebarBox?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${dashboardCard1Object?.sidebarBox?.borderRadius?.topLeft?.value}${dashboardCard1Object?.sidebarBox?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${dashboardCard1Object?.sidebarBox?.borderRadius?.topRight?.value}${dashboardCard1Object?.sidebarBox?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${dashboardCard1Object?.sidebarBox?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.sidebarBox?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${dashboardCard1Object?.sidebarBox?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.sidebarBox?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"5px"}}> <button className="close-btnsidebarD buttonDashB" onClick={onClose}>✕</button>
      <div className="sidebarD-header" style={{background:`${dashboardCard1Object?.sidebarHeader?.bgColor?.color}`,
border:` ${dashboardCard1Object?.sidebarHeader?.border?.borderWidth?.value+dashboardCard1Object?.sidebarHeader?.border?.borderWidth?.resolution} ${dashboardCard1Object?.sidebarHeader?.border?.borderType}  ${dashboardCard1Object?.sidebarHeader?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${dashboardCard1Object?.sidebarHeader?.borderRadius?.topLeft?.value}${dashboardCard1Object?.sidebarHeader?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${dashboardCard1Object?.sidebarHeader?.borderRadius?.topRight?.value}${dashboardCard1Object?.sidebarHeader?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${dashboardCard1Object?.sidebarHeader?.borderRadius?.bottomLeft?.value}${dashboardCard1Object?.sidebarHeader?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${dashboardCard1Object?.sidebarHeader?.borderRadius?.bottomRight?.value}${dashboardCard1Object?.sidebarHeader?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"8px",marginTop:"7px",padding:"5px",color:`${dashboardCard1Object?.sidebarHeader?.textColor?.color}`}}>
       
       <div className="profileDash"style={{paddingTop:"10px"}}>
        <div className="avatarDash dashboardPageTitleFont"><ImageFallFB  boxShadow={``}
                      src={dashboardCard1Object?.profileImageThumbnail?.src}
                      border={dashboardCard1Object?.profileImageThumbnail?.border?.borderWidth?.value+dashboardCard1Object?.profileImageThumbnail?.border?.borderWidth?.resolution+" "+dashboardCard1Object?.profileImageThumbnail?.border?.borderType +" "+dashboardCard1Object?.profileImageThumbnail?.border?.borderColor?.color}
                      width={ 100
                      }
                      aspectRatio={dashboardCard1Object?.profileImageThumbnail?.aspectRatio?.value}
                      borderRadius={ dashboardCard1Object?.profileImageThumbnail?.borderRadius
                      }/></div>
        <h4 className="dashboardPageTitleFont">kaushal</h4>
        <p className="dashboardPageTagsFont">0 Courses · 1 Following</p>
      </div>
      </div>

      <div className="sidebarDDashBNav"  onClick={onClose}>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={false} pageDB={pageDB} name={""} setPageDB={setPageDB} icon={0} title={"Dashboard"}/>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"dashboard"} setPageDB={setPageDB} icon={1} title={"My Dashboard"}/>
       <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"courses"} setPageDB={setPageDB} icon={2} title={"My Enrollments"}/>
       <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"orders"} setPageDB={setPageDB} icon={3} title={"My Purchase History"}/>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"wishlist"} setPageDB={setPageDB} icon={4} title={"My Wishlist"}/>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"cart"} setPageDB={setPageDB} icon={5} title={"My Cart"}/>

            {/* <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"certificates"} setPageDB={setPageDB} icon={8} title={"My Certificates"}/>
          <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"groups"} setPageDB={setPageDB} icon={9} title={"My Groups"}/>
         
         <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={false} pageDB={pageDB} name={""} setPageDB={setPageDB} icon={10} title={"Events"}/>
         <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"events"} setPageDB={setPageDB} icon={11} title={"My Events"}/>
        
           <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={false} pageDB={pageDB} name={""} setPageDB={setPageDB} icon={12} title={"Batches"}/>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"batches"} setPageDB={setPageDB} icon={13} title={"My Batches"}/>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"timetable"} setPageDB={setPageDB} icon={14} title={"Time Table"}/>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"attendance"} setPageDB={setPageDB} icon={15} title={"My Attendance"}/>
        <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"homework"} setPageDB={setPageDB} icon={16} title={"Homework"}/>
      
          <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={false} pageDB={pageDB} name={""} setPageDB={setPageDB} icon={17} title={"Launch Pad"}/>
       <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"performance"} setPageDB={setPageDB} icon={18} title={"My Performance"}/>
       <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"liveSessions"} setPageDB={setPageDB} icon={19} title={"Live Sessions"}/>
       <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"assessments"} setPageDB={setPageDB} icon={20} title={"My Assessments"}/>
      <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"announcements"} setPageDB={setPageDB} icon={21} title={"Announcements"}/>
      <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"qna"} setPageDB={setPageDB} icon={22} title={"QnA & Doubts"}/> */}
      
           <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={false} pageDB={pageDB} name={""} setPageDB={setPageDB} icon={23} title={"My Space"}/>
     <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"ebooks"} setPageDB={setPageDB} icon={22} title={"Ebooks & PDFs"}/>
     <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"bookmarks"} setPageDB={setPageDB} icon={24} title={"Bookmarks"}/>
     <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"comments"} setPageDB={setPageDB} icon={25} title={"Comments"}/>
     <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"notes"} setPageDB={setPageDB} icon={26} title={"Notes"}/>
     <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"reviews"} setPageDB={setPageDB} icon={27} title={"Reviews"}/>
     <SidebarNavItems  dashboardCard1Object={dashboardCard1Object}  clickActive={true} pageDB={pageDB} name={"reports"} setPageDB={setPageDB} icon={28} title={"Reports"}/>
     
      
       
    
        <SidebarNavItems    dashboardCard1Object={dashboardCard1Object} clickActive={true} name={"settings"}  pageDB={pageDB} setPageDB={setPageDB} icon={6} title={"Settings"}/>
         <SidebarNavItems    dashboardCard1Object={dashboardCard1Object} clickActive={false}   name={"logout"} pageDB={pageDB}setPageDB={setPageDB} icon={7} title={"Log out"}/>
        </div>
      <style>{`
      .sidebarD {
  width: 240px;position:relative;
  overflow-y: auto;
 
  padding: 20px; 
}


.profileDash {
  text-align: center;
}

.avatarDash {
  width: 80px;
  height: 80px;
  background: #e6f4ea;
  border-radius: 50%;
  margin: auto;
  display: grid;
  place-items: center;
  font-weight: 600;
}


.logoutDash {
  color: #e74c3c;
}

.sidebarD .sidebarDDashBNav a {
  display: flex;justify-content: start;gap:10px;
  padding: 12px; 
  font-family:${dashboardCard1Object?.titleFonts?.buttonFont?.family?.fontFamily};;
  color: ${dashboardCard1Object?.sidebarNavBtn?.textColor?.color};
  text-decoration: none;

  margin-bottom: 6px;
}

.sidebarD .sidebarDDashBNav a.activeDashNav{
 background:${dashboardCard1Object?.sidebarNavBtn?.bgColor?.colors.color3}  !important;

}.sidebarD .sidebarDDashBNav a.accordionDashNav{
  background:${dashboardCard1Object?.sidebarNavBtn?.bgColor?.colors.color6}  !important;
 
}
.sidebarD .sidebarDDashBNav a:hover {
 background:${dashboardCard1Object?.sidebarNavBtn?.bgColor?.colors.color1}  ;
      }
 .buttonDashB {
  font-family: inherit;
  font-size: 14px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.buttonDashB:hover {
  transform: translateY(-1px);
}
.close-btnsidebarD {
  background: none;position:absolute;top:0px;right:0px;border-radius:50%;width:30px;height:30px;
  font-size: 20px;background:${dashboardCard1Object?.sidebarNavBtn?.bgColor?.colors.color1}  ;
}
@media (max-width: 768px) {

  .sidebarD {
    width: 100%;padding-top: 80px;padding-bottom: 60px;
    border-right: none;
    border-bottom: 1px solid #eee;
  }
.close-btnsidebarD {
  background: none;position:absolute;top:60px;right:0px;border-radius:50%;width:30px;height:30px;
  font-size: 20px;background:${dashboardCard1Object?.sidebarNavBtn?.bgColor?.colors.color1}  ;
}
/* Sidebar default (hidden on mobile) */
.sidebarD {
  position: fixed;
  left: 0;
  top: 0;
  height: 88vh;
  width: 260px;
  background: #fff;
  z-index: 1001;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

}

/* Sidebar visible */
.sidebarD-open .sidebarD {
  transform: translateX(0);
}

/* Overlay */
.sidebarD-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 1000;
}

.sidebarD-open .sidebarD-overlay {
  opacity: 1;
  pointer-events: all;
}

/* Sidebar header */
.sidebarD-header {
  display: flex;
  justify-content: center;
  align-items: center;
 
}



/* -----------------------------
   TOPBAR MENU BUTTON
------------------------------ */
.menu-btnsidebarD {
  font-size: 22px;border-radius:50%;width:35px;height:35px;background:${dashboardCard1Object?.sidebarNavBtn?.bgColor?.colors.color1}  ;
 
  border: none;
  cursor: pointer;
  display: block;
}
 
`}</style>
    </aside>
  );
}
